<template>
 <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >{{$t('apiDoc.在线文档')}}</span>
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >{{$t('apiDoc.测试工具')}}</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
 import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";


import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'threeCode/getThreeSegmentCode';
export default {
  components: { onlineDoc , apiTestDoc },
  data() { 
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`,
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
       postDataList:[
            
        //   请求头参数
            {
                title:'Headers',
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`, },
                    {name: "digest",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.签名字符串')}`, },
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.时间戳，毫秒')}`,}
                    ]
            },
             { 
                title:`${this.$t('onlineDoc.请求参数')}`, 
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: `${this.$t('onlineDoc.业务参数')}`,describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`,},
                ]
            },
            {
              title:`${this.$t('onlineDoc.业务参数')}`,
              value:[
                {name: "sender",type: "Object",require: "N",normal: "",describe: `${this.$t('onlineDoc.寄件信息对象')}`},
                {name: "receiver",type: "Object",require: "Y",normal: "",describe:`${this.$t('onlineDoc.收件信息对象')}`, }
              ]
            },
            {
              title:`${this.$t('onlineDoc.sender类型说明')}`,
              value:[
                {name: "countryCode",type: "String(20)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.ThreeCharacterSending')}`},
                {name: "prov",type: "String(32)",require: "Y",normal: "",describe:`${this.$t('onlineDoc.寄件酋长国')}`},
                {name: "city",type: "String(32)",require: "Y",normal: "",describe:`${this.$t('onlineDoc.寄件区域')}`},
                // {name: "area",type: "String(32)",require: "Y",normal: "",describe:`${this.$t('onlineDoc.寄件街道')}`},
                // {name: "town",type: "String(32)",require: "N",normal: "",describe:"寄件乡镇"},
                {name: "street",type: "String(32)",require: "N",normal: "",describe:`${this.$t('onlineDoc.寄件街道')}`},
                {name: "address",type: "String(150)",require: "Y",normal: "",describe:`${this.$t('onlineDoc.ShippingDetailedAddress')}`}
              ]
            },
            {
              title:`${this.$t('onlineDoc.receiver类型说明')}`,
              value:[
                {name: "countryCode",type: "String(20)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.ThreeCharacterRecipient')}`},
                {name: "prov",type: "String(32)",require: "Y",normal: "",describe:`${this.$t('onlineDoc.收件酋长国')}`},
                {name: "city",type: "String(32)",require: "Y",normal: "",describe:`${this.$t('onlineDoc.收件区域')}`},
                // {name: "area",type: "String(32)",require: "Y",normal: "",describe:`${this.$t('onlineDoc.收件街道')}`},
                // {name: "town",type: "String(32)",require: "N",normal: "",describe:"收件乡镇"},
                {name: "street",type: "String(32)",require: "N",normal: "",describe:`${this.$t('onlineDoc.收件街道')}`},
                {name: "address",type: "String(150)",require: "Y",normal: "",describe:`${this.$t('onlineDoc.ReceivingDetailedAddress')}`}
              ]
            },

        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[
            
        //   响应参数
            {
                title:`${this.$t('onlineDoc.响应参数')}`,
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: `${this.$t('onlineDoc.返回码，见附录')}`,},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.描述')}`,},
                    {name: "data",type: "Object",require: "Y",normal: "",describe: `${this.$t('onlineDoc.业务数据')}`,},
                  ]
            },
            {
              title:`${this.$t('onlineDoc.data类型说明')}`,
              value:[
                  {name: "lastCenterName",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.集包地')}`},
                  {name: "sortingCode",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.三段码online')}`}
                ]
            }

        ],
        //请求示例
        requestCode: `Header：
    apiAccount=292508153084379141
    Content-Type=application/x-www-form-urlencoded
    digest=djEINdkT7aLeivrvhf91SQ==
    timestamp=1648536570679

Body：
    bizContent={
      "sender":{
        "address": 'cdscds 13211cdssأتحقق من ذلك شكرا',
        "town": 'town1',
        "street": 'street1',
        "city": 'Al Baha',
        "countryCode": 'KSA',
        "prov": 'Al Baha'
        },
      "receiver":{
        'address': 'King Fahd Rd Riyadhأتحقق من ذلك شكرا',
        'town': 'dddddd',
        'street': 'aaasssss',
        'city': 'Al Arja',
        'countryCode': 'KSA',
        'prov': 'Riyadh'
      }
    }`,
        //返回示例
        responseCode: JSON.parse(`{
    "code": "1",
    "msg": "success",
    "data": {
      "lastCenterName":"Dubai DC",
      "sortingCode":"DC04-CN011-"
    }
}`),

        //错误代码提示
        errcodeJson: [{code:"145003083",msg:`${this.$t('apiTestDoc.始发地信息不全')}`},{code:"145003084",msg:`${this.$t('apiTestDoc.收货地信息不全')}`}]
      },

      apiTestData: {
          _headerData: {
            apiAccount: "292508153084379141",
            digest: "U40e5sumorgd3YgZzU61Mw==",
            timestamp: "1565238848921",
          },
          data:{
             bizContent: `{'receiver': {'address': 'King Fahd Rd Riyadhأتحقق من ذلك شكرا', 'town': 'dddddd', 'street': 'aaasssss', 'city': 'Al Arja', 'countryCode': 'KSA', 'prov': 'Riyadh'}, 'sender': {'address': 'cdscds 13211cdssأتحقق من ذلك شكرا', 'town': 'town1', 'street': 'street1', 'city': 'Al Baha', 'countryCode': 'KSA', 'prov': 'Al Baha'}}`,
          },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
        //错误代码提示
        errcodeJson: [{code:"145003083",msg:`${this.$t('apiTestDoc.始发地信息不全')}`},{code:"145003084",msg:`${this.$t('apiTestDoc.收货地信息不全')}`}]
      },
    };
  },
 created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
 }
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>